// extracted by mini-css-extract-plugin
export default {"themeToggle":"ThemeToggle_themeToggle__PqZrY","toggleTrack":"ThemeToggle_toggleTrack__obmNL","toggleThumb":"ThemeToggle_toggleThumb__B-+SF","dark":"ThemeToggle_dark__fBzLE"};